import styled, { css } from 'styled-components';

export const Title = styled.h2(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    margin: 0;
    color: ${theme.co.neutral10};
  `,
);

export {
  OptionButton,
  OptionDescription,
  OptionIcon,
  OptionsList,
  OptionText,
  OptionTitle,
} from '../sharedStyles';
